import { createContext } from "react";

const ChannelsDataContext = createContext(null);

export default ChannelsDataContext;